import secureLocalStorage from "react-secure-storage";
import { sendLogoutUser } from "../js/api/auth";
import forge from 'node-forge';
const token = "userToken";
let formatter;
const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];


export const login = (msg) => {
    localStorage.setItem(token, msg);
}

export const logoutUser = async () => {
    if (isLogin()) {
        document.getElementsByTagName("body")[0].classList.add("loading-screen")
        try {
            await sendLogoutUser();
        } catch (error) {
            console.error(error);
        }
        document.getElementsByTagName("body")[0].classList.remove("loading-screen")
        sessionStorage.clear();
        secureLocalStorage.clear();
        localStorage.removeItem(token);
        window.location.replace('/');
    }
};


export const isLogin = () => {
    if (localStorage.getItem(token)) {
        return true;
    }
    return false;
}

export const validateChangePassword = (validateForm) => {
    let errors = {}
    var regexValidatePassword = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^!&*+=]).*$/;
    if (!validateForm.newPassword) {
        errors.newPassword = "Please Enter New Password";
    }
    if (!validateForm.confirmPassword) {
        errors.confirmPassword = "Please Enter Confirm Password";
    }
    else if (validateForm.newPassword !== validateForm.confirmPassword) {
        errors.confirmPassword = "New password and confirm password must be same";
    }
    else if (!regexValidatePassword.test(validateForm.confirmPassword)) {
        errors.confirmPassword = "Please Follow the given pattern ";
    }
    return errors;
}

export const validateLogin = (form) => {
    let errors = {}
    if (isEmpty(form.username)) {
        errors.username = "Please Enter Username";
    }
    if (isEmpty(form.password)) {
        errors.password = "Please Enter Password";
    }
    return errors;

}
export const isEmpty = (value) => (
    value === undefined ||
    value === null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
)

export const handleAESEncrypt = (AES, plainText) => {
    const key = forge.util.hexToBytes(AES);
    let iv = forge.random.getBytesSync(16);
    const ivHex = forge.util.bytesToHex(iv);
    iv = forge.util.hexToBytes(ivHex);
    const cipher = forge.cipher.createCipher('AES-CBC', key);
    cipher.start({ iv });
    cipher.update(forge.util.createBuffer(plainText, 'utf8'));
    cipher.finish();
    const encrypted = cipher.output.toHex(); // Use hex for consistency

    return [ivHex, encrypted];
};

export const handleRSAEncrypt = (plainText) => {
    let encrypted = window.handleRSA.encryptMessage(plainText, process.env.REACT_APP_API_PUBLIC_KEY);
    return encrypted;
}

export const saltGeneration = (inputData, accessToken = false) => {
    let saltData = JSON.parse(JSON.stringify(inputData));
    saltData.clientSalt = forge.util.bytesToHex(forge.random.getBytesSync(16));
    saltData = JSON.stringify(saltData);
    let encryptedPass = handleRSAEncrypt(saltData);
    if (accessToken) {
        accessToken = `Bearer ${accessToken}`;
        secureLocalStorage.setItem("TDB-Auth", accessToken);
    }
    return [encryptedPass, saltData, accessToken];
}

export const setLoginSuccess = (promoterDetails, saltData) => {
    sessionStorage.setItem("userDetails", JSON.stringify(promoterDetails));
    secureLocalStorage.setItem("TDB-TOKEN", promoterDetails.secret_token)
    secureLocalStorage.setItem("OFFSETS", {
        userId: promoterDetails.userId,
        clientSalt: JSON.parse(saltData).clientSalt,
        serverSalt: promoterDetails.offset2
    })

    delete promoterDetails['secret_token'];
    delete promoterDetails['offset2'];
    return promoterDetails;
}

export const encryptRequestData = (request) => {
    const saltObj = secureLocalStorage.getItem("OFFSETS");
    const saltKey = `${saltObj.clientSalt}${saltObj.serverSalt}`;
    let [ivHex, encrypted] = handleAESEncrypt(saltKey, JSON.stringify(request));

    const headers = {
        'hash-request': encrypted,
        'hash-iv': ivHex
    };
    return headers;
}
export const handleRSAVerify = (originalText, signedText) => {
    if (originalText === false || originalText === false) {
        return false;
    }
    let verified = window.handleRSA.verifyMessage(originalText, signedText, process.env.REACT_APP_API_PUBLIC_KEY);
    return verified;
}

export const getOptionObject = (data, format = "m") => {
    if (format === "m") {
        return { value: data, label: getMonthInWord(data)};
    } else {
        return { value: data, label: data };
    }
}

export const getMonthInWord = (monthNumber) => {
    const monthName = months[monthNumber-1];
    return monthName;
}

export const getNumberToCurrency = () => {
    if(!formatter) {
        formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "PHP",
        });
    }
    return formatter;
}

export const getDownPayModalObject = (logic) => {
    return {
        showDownPay: logic.showDownPay,
        handleDownPayClose: logic.handleDownPayClose,
        formatter: logic.formatter,
        downPayment: logic.downPayment,
        handledownpayChange: logic.handledownpayChange,
        handleDecimalNumbers: logic.handleDecimalNumbers,
        handlePasteDecimalNumbers: logic.handlePasteDecimalNumbers,
        RBPObject: logic.RBPObject,
        disableApplynow: logic.disableApplynow,
        handleApplyNow: logic.handleApplyNow
    };
}

export const getCompareModalObject = (logic) => {
    return {
        showCompareModal: logic.showCompareModal,
        handleCompareModalClose: logic.handleCompareModalClose,
        setShowCompareModal: logic.setShowCompareModal,
        downPayment: logic.downPayment,
        totalAmount: logic.totalAmount,
        allItems: logic.allItems,
        currentSegmentObj: logic.currentSegmentObj,
        RBPObject: logic.RBPObject,
        loanableAmount: logic.loanableAmount,
        handleApplyNow: logic.handleApplyNow,
        setSelected: logic.setSelected,
        getEMIDetails: logic.getEMIDetails,
        merchantStore: logic.merchantStore,
        isSilZero: logic.isSilZero,
        applicationType: logic.applicationType
    };
}

export const getAssessmentObject = (logic) => {
    return {
        solarFinance: logic.solarFinance,
        assesmentPopup: logic.assesmentPopup,
        assesmentPopupClose: logic.assesmentPopupClose,
        setcheckboxValueOption1: logic.setcheckboxValueOption1,
        isCheckedOption1: logic.isCheckedOption1,
        setcheckboxValueOption2: logic.setcheckboxValueOption2,
        isCheckedOption2: logic.isCheckedOption2,
        setAssesmentValue: logic.setAssesmentValue,
        promotorConcernDetails: logic.promotorConcernDetails,
        disableProceed: logic.disableProceed,
        proceedQRInfo: logic.proceedQRInfo
    };
}

export const isAlphanumeric = (value) => {
    return /^[a-z0-9]+$/i.test(value);
}

// Returns a handler that navigates back to the Add-items page.
export const getBackToItemsPage = (navigate) => () => {
    navigate("/Add-items", { replace: true });
};

// Assembles the props consumed by the <Authentication /> modal. No-op handler
// defaults let callers (e.g. the completion-error popup) supply only what they use.
export const getAuthenticationObject = ({
    show,
    data,
    merchantName,
    errorActionLabel,
    onPollStatus = () => {},
    onReAttempt = () => {},
    onContinue = () => {},
    onCooldownEnd = () => {},
    onScanNew = () => {},
    onClose = () => {},
} = {}) => {
    return {
        show,
        data,
        merchantName,
        errorActionLabel,
        onPollStatus,
        onReAttempt,
        onContinue,
        onCooldownEnd,
        onScanNew,
        onClose,
    };
};

// Builds the props passed to <DetailsContent /> from the router location state.
export const getDetailsContentProps = (state, backToItemsPage) => {
    return {
        sourceBtn: state?.source_btn,
        productDetails: state?.productDetails,
        RBPObject: state?.RBPObject,
        currentSegment: state?.currentSegment,
        isProcessFeeApplicable: state?.isProcessFeeApplicable,
        backToItemsPage,
    };
};